import {grid, gridItem} from '~/design-system/foundations'
import HgPricingCardsClient from './client'
import {type HgPricingCardsProps} from './types'
import {Suspense} from 'react'
import {HgPricingCardsFallback} from './skeleton'

export default function HgPricingCards(props: HgPricingCardsProps) {
  return (
    <div className="w-full" data-nosnippet={true}>
      <div className={grid({className: 'mx-auto pt-s9'})}>
        <div
          className={gridItem({
            size: 'max',
            className:
              'flex flex-col items-center rounded-xl bg-surface-elevated shadow-[0px_10px_16px_0px_rgba(28,28,35,0.02),0px_6px_10px_0px_rgba(28,28,35,0.04),0px_0px_3px_0px_rgba(28,28,35,0.09)]',
          })}
        >
          <Suspense fallback={<HgPricingCardsFallback {...props} />}>
            <HgPricingCardsClient {...props} />
          </Suspense>
        </div>
      </div>
    </div>
  )
}
